define('SEOTagsPerWebsite', [
  'underscore'
], function KodellaSEOTagsPerWebsite(
  _
) {
  'use strict';

  var ProductDetailsFullView;
  var SEOTagsConfig;

  try {
    ProductDetailsFullView = require('ProductDetails.Full.View');
    if (ProductDetailsFullView) {
      _.extend(ProductDetailsFullView.prototype, {
        getContext: _.wrap(ProductDetailsFullView.prototype.getContext, function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          var defaultPageTitle = this.model.get('item').get('_pageTitle');
          var customPageTitleField = SEOTagsConfig && SEOTagsConfig.pageTitle;
          var customPageTitleData = customPageTitleField && this.model.get('item').get(customPageTitleField);
          var displayDefault = SEOTagsConfig && SEOTagsConfig.pageTitleDisplayDefaultValueIfEmpty;

          var defaultPageHeader = this.model.get('item').get('_pageHeader');
          var customPageHeaderField = SEOTagsConfig && SEOTagsConfig.webStoreDisplayName;
          var customPageHeaderData = customPageHeaderField && this.model.get('item').get(customPageHeaderField);
          var displayDefaultPageheader = SEOTagsConfig && SEOTagsConfig.webStoreDisplayNameDisplayDefaultValueIfEmpty;

          if (!customPageTitleData && displayDefault) {
            this.title = defaultPageTitle;
            context.title = defaultPageTitle;
          } else {
            this.title = customPageTitleData;
            context.title = customPageTitleData;
          }

          if (!customPageHeaderData && displayDefaultPageheader) {
            this.pageHeader = defaultPageHeader;
            context.pageHeader = defaultPageHeader;
          } else {
            this.pageHeader = customPageHeaderData;
            context.pageHeader = customPageHeaderData;
          }

          return context;
        }),

        getDefaultMetaKeywords: function getDefaultMetaKeywords() {
          return (
            this.metaKeywords ||
						(this.getMetaTags().filter('[name="keywords"]').attr('content') || '')
          );
        },
        getMetaKeywords: function getMetaKeywords() {
          var defaultMetaKeywords = this.getDefaultMetaKeywords();
          var customMetaKeywordsField = SEOTagsConfig && SEOTagsConfig.metaTagKeywords;
          var customMetaKeywordsData = customMetaKeywordsField && this.model.get('item').get(customMetaKeywordsField);
          var displayDefault = SEOTagsConfig && SEOTagsConfig.metaTagKeywordsDisplayDefaultValueIfEmpty;

          if (!customMetaKeywordsData && displayDefault) {
            return defaultMetaKeywords;
          }

          return customMetaKeywordsData;
        },
        getDefaultMetaDescription: function getDefaultMetaDescription() {
          return (
            this.metaDescription ||
						(this.getMetaTags().filter('[name="description"]').attr('content') || '')
          );
        },
        getMetaDescription: function getMetaDescription() {
          var defaultMetaDescription = this.getDefaultMetaDescription();
          var customMetaDescriptionfield = SEOTagsConfig && SEOTagsConfig.metaTagDescription;
          var customMetaDescriptionData = customMetaDescriptionfield && this.model.get('item').get(customMetaDescriptionfield);
          var displayDefault = SEOTagsConfig && SEOTagsConfig.metaTagDescriptionDisplayDefaultValueIfEmpty;

          if (!customMetaDescriptionData && displayDefault) {
            return defaultMetaDescription;
          }
          return customMetaDescriptionData;
        }
      });
    }
  } catch (e) {
    console.log(e);
  }

  return {
    mountToApp: function mountToApp(container) {
      var env = container.getComponent('Environment');
      SEOTagsConfig = env && env.getConfig('SEOTagsPerWebsite');
    }
  };
});
